<div class="json-diff">
  <h4>{{ 'CONFIGURATION.LOGS.DIFF_TITLE' | translate }}</h4>

  <div class="diff-headers">
    <div class="diff-header">{{ 'USER_ACTIONS.FROM' | translate }}</div>
    <div class="diff-header">{{ 'USER_ACTIONS.TO' | translate }}</div>
  </div>

  <div class="diff-body">
    <div class="diff-row" *ngFor="let row of rows" [class.changed]="row.changed">
      <pre class="diff-cell">{{ row.left }}</pre>
      <pre class="diff-cell">{{ row.right }}</pre>
    </div>
  </div>

  <div class="buttons">
    <button mat-button color="primary" (click)="exit()">
      {{ 'COMMON.OK' | translate }}
    </button>
  </div>
</div>
